
import { BaseTextEditorModel } from './base-text-editor-model';
import { URI } from '@vscode-alt/monaco-editor/esm/vs/base/common/uri';
import { IModeService, IModelService } from '@workbench-stack/core';


/**
 * An editor model whith an in-memory, readonly content that is backed by an existing editor model.
 */
export class ResourceEditorModel extends BaseTextEditorModel {

	constructor(
		resource: URI,
		modeService: IModeService,
		modelService: IModelService
	) {
		super(modelService, modeService, resource);
	}

	isReadonly(): boolean {
		return true;
	}

	dispose(): void {

		// TODO@Joao: force this class to dispose the underlying model
		if (this.textEditorModelHandle) {
			this.modelService.destroyModel(this.textEditorModelHandle);
		}

		super.dispose();
	}
}